import React, { useRef, useState, useMemo, useEffect } from 'react';
import { guestUploadPhoto } from '../services/apiService';
import '../index.css';

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const isVideoFile = (file) => {
  if (file.type.startsWith('video/')) return true;
  const videoExtensions = ['.mov', '.mp4', '.webm', '.ogg', '.avi', '.mkv', '.qt'];
  const fileName = file.name.toLowerCase();
  return videoExtensions.some(ext => fileName.endsWith(ext));
};

// ✅ YENİ: Bilgilendirme Toast Bileşeni
const SlowUploadToast = () => (
  <div style={{
    position: 'fixed',
    bottom: '24px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 9999,
    backgroundColor: 'rgba(30, 30, 40, 0.93)',
    color: '#fff',
    borderRadius: '14px',
    padding: '14px 20px',
    maxWidth: '340px',
    width: '90vw',
    boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    backdropFilter: 'blur(8px)',
    animation: 'fadeInUp 0.3s ease',
  }}>
    <span style={{ fontSize: '22px', flexShrink: 0, marginTop: '1px' }}>📸</span>
    <div>
      <div style={{ fontWeight: '700', fontSize: '0.92rem', marginBottom: '4px' }}>
        Yükleme Devam Ediyor...
      </div>
      <div style={{ fontSize: '0.81rem', lineHeight: '1.4', color: 'rgba(255,255,255,0.82)' }}>
        Görüntü kalitesi korunduğundan dolayı, yüksek çözünürlükte içeriklerin yüklenmesi biraz daha uzun sürebilir. Lütfen bekleyin.
      </div>
    </div>
  </div>
);

const UploadForm = ({ onUpload, weddingId, uploadedByEmail, uploadsLocked = false, album, caption, setCaption }) => {
  const fileInputRef = useRef(null);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [showSlowToast, setShowSlowToast] = useState(false);

  // ✅ YENİ: Yükleme Yüzdesi State'i
  const [uploadProgress, setUploadProgress] = useState(0);

  const totalSize = useMemo(
    () => selectedFiles.reduce((acc, { file }) => acc + file.size, 0),
    [selectedFiles]
  );

  useEffect(() => {
    return () => {
      selectedFiles.forEach((it) => it.previewUrl && URL.revokeObjectURL(it.previewUrl));
    };
  }, [selectedFiles]);

  // ✅ YENİ: Büyük dosya veya video seçildiğinde ya da sunucu işlemesinde toast göster
  useEffect(() => {
    if (!isUploading) {
      setShowSlowToast(false);
      return;
    }
    // Yükleme sırasında her zaman göster
    setShowSlowToast(true);
  }, [isUploading]);

  const handleFileChange = (e) => {
    if (uploadsLocked) return;
    const files = e.target.files;
    if (files && files.length > 0) {
      if (selectedFiles.length + files.length > 15) {
        alert("Tek seferde en fazla 15 dosya seçebilirsiniz.");
        e.target.value = '';
        return;
      }

      // ✅ YENİ: Video veya büyük dosya seçildiyse hemen toast göster (seçim esnasında uyarı)
      const hasLargeOrVideo = Array.from(files).some(f => isVideoFile(f) || f.size > 20 * 1024 * 1024);
      if (hasLargeOrVideo) {
        setShowSlowToast(true);
        setTimeout(() => setShowSlowToast(false), 5000);
      }

      const newFiles = Array.from(files).map((file, idx) => ({
        id: `${file.name}-${Date.now()}-${idx}-${Math.random().toString(36).substr(2, 9)}`,
        file,
        // Video dosyaları için previewUrl oluşturmuyoruz - tarayıcı videoyu buffer'lamaya
        // çalışarak UI'ı donduruyor. Onun yerine basit bir ikon gösteriyoruz.
        previewUrl: isVideoFile(file) ? null : URL.createObjectURL(file),
      }));
      setSelectedFiles((current) => [...current, ...newFiles]);
      setMessage('');
      setIsSuccess(false);
      setUploadProgress(0);
      e.target.value = ''; // Clear input value so same files can be re-selected and memory is released
    }
  };

  const handleRemoveFile = (idToRemove) => {
    const toRemove = selectedFiles.find((it) => it.id === idToRemove);
    if (toRemove && toRemove.previewUrl) URL.revokeObjectURL(toRemove.previewUrl);
    setSelectedFiles((current) => current.filter((it) => it.id !== idToRemove));
  };

  const handleUpload = async () => {
    if (uploadsLocked) return;
    if (selectedFiles.length === 0) {
      setMessage('Lütfen dosya seçin.');
      return;
    }

    setIsUploading(true);
    setUploadProgress(0); // Başlarken sıfırla
    setMessage('Yükleniyor...');
    setIsSuccess(false);

    try {
      const filesToSend = selectedFiles.map(f => f.file);

      // ✅ GÜNCELLEME: onProgress callback'ini doğru sırayla (5. argüman) gönderiyoruz
      await guestUploadPhoto(filesToSend, weddingId, album || 'Tümü', caption, (percent) => {
        setUploadProgress(percent);
        // Kullanıcıya % bilgisini mesaj olarak da gösterebiliriz veya sadece barda tutabiliriz
        if (percent < 100) {
          setMessage(`Yükleniyor... %${percent}`);
        } else {
          setMessage('Sunucu işliyor... (Lütfen bekleyin)');
        }
      });

      handleSuccess('Yükleme Başarılı! ✅');

    } catch (error) {
      console.error("Yükleme yanıtı:", error);

      const isTimeout = error.status === 500 ||
        (error.message && (
          error.message.includes('Timeout') ||
          error.message.includes('timed out') ||
          error.message.includes('Internal Server Error')
        ));

      if (isTimeout) {
        setUploadProgress(100); // Timeout olsa bile 100% gösterelim
        handleSuccess('Yükleme tamamlandı. (Sunucu yanıtı gecikti ama dosyalarınız alındı.)');
      } else if (error?.status === 423) {
        setMessage('Yüklemeler kilitlendi.');
        setIsUploading(false);
        setUploadProgress(0);
      } else {
        const errorMsg = error.message || "Bilinmeyen hata";
        setMessage(`Hata: ${errorMsg}`);
        setIsUploading(false);
        setIsSuccess(false);
        setUploadProgress(0);
      }
    }
  };

  const handleSuccess = (msg) => {
    setIsSuccess(true);
    setMessage(msg);
    setUploadProgress(100);
    setIsUploading(false);
    setShowSlowToast(false);

    setTimeout(() => {
      selectedFiles.forEach((it) => it.previewUrl && URL.revokeObjectURL(it.previewUrl));
      setSelectedFiles([]);
      setCaption('');
      setMessage('');
      setIsSuccess(false);
      setUploadProgress(0);
      if (fileInputRef.current) fileInputRef.current.value = '';
      if (onUpload) onUpload();
    }, 2000);
  };

  const disabled = uploadsLocked || isUploading;

  return (
    <div className="upload-container">
      {/* ✅ YENİ: Yavaş Yükleme Bildirimi (Toast) */}
      {showSlowToast && <SlowUploadToast />}

      <input
        ref={fileInputRef}
        type="file"
        id="file-upload"
        accept="image/*,video/*"
        onChange={handleFileChange}
        style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: '0',
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          border: '0',
          opacity: 0,
        }}
        multiple
        disabled={disabled}
      />

      <label
        htmlFor="file-upload"
        className={`upload-button ${disabled ? 'is-disabled' : ''}`}
        style={{ marginBottom: '1rem' }}
      >
        Dosya Seç (Tek seferde maks 15)
      </label>

      {selectedFiles.length > 0 && (
        <div className="preview-container">
          <div className="upload-summary" style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <p>
              {selectedFiles.length} dosya seçildi
              <br />
              <span style={{ fontSize: '0.85rem', color: '#666' }}>
                Toplam: {formatBytes(totalSize)}
              </span>
            </p>
          </div>

          <div className="preview-grid">
            {selectedFiles.map(({ id, file, previewUrl }) => (
              <div key={id} className="preview-item">
                {file.type.startsWith('image/') ? (
                  <img src={previewUrl} alt={file.name} className="preview-media" />
                ) : isVideoFile(file) ? (
                  // Video önizlemesi render etmiyoruz — mobilde tarayıcı videoyu
                  // buffer'lamaya çalışarak ekranı dondurur. Hafif ikon yeterli.
                  <div className="preview-generic" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                    color: '#fff',
                    gap: '4px',
                    padding: '8px',
                    boxSizing: 'border-box',
                    width: '100%',
                    height: '100%',
                  }}>
                    <span style={{ fontSize: '2rem' }}>🎬</span>
                    <span style={{ fontSize: '0.65rem', wordBreak: 'break-all', textAlign: 'center', maxWidth: '90%', opacity: 0.85 }}>
                      {file.name.length > 20 ? file.name.substring(0, 18) + '…' : file.name}
                    </span>
                  </div>
                ) : (
                  <div className="preview-generic">📄</div>
                )}

                {!isUploading && (
                  <button
                    type="button"
                    className="remove-file-btn"
                    onClick={() => handleRemoveFile(id)}
                    disabled={disabled}
                  >
                    &times;
                  </button>
                )}
              </div>
            ))}
            <div style={{
              borderRadius: '8px',
              marginTop: '15px',
              padding: '0',

              // ✅ KRİTİK GÜNCELLEME: Tüm sütunları kapla
              width: '100%',
              gridColumn: '1 / -1',
              textAlign: 'left' // İçindeki başlık ve metinleri sola yasla

            }}>
              <h3 style={{
                fontSize: '1rem',
                marginBottom: '8px',
                fontWeight: '600',
                padding: '0 20px', // Başlığa yatay padding veriyoruz
                textAlign: 'left'
              }}>
                Tüm Fotoğraflara Yorum Ekle (Opsiyonel)
              </h3>
              <textarea
                value={caption}
                onChange={(e) => setCaption(e.target.value)}
                placeholder="Bu dosyalar için bir anı veya not girin (Maks. 200 karakter)"
                maxLength={200}
                rows={3}
                disabled={disabled}
                style={{
                  width: '100%',
                  // KRİTİK: Yatayda padding verip, border ve padding'i genişliğe dahil ediyoruz.
                  padding: '10px 20px',
                  borderRadius: '6px',
                  border: '1px solid var(--theme-color, #ccc)',
                  resize: 'none',
                  boxSizing: 'border-box',
                  opacity: disabled ? 0.7 : 1
                }}
              />
              <p style={{
                fontSize: '0.8rem',
                color: '#999',
                marginTop: '5px',
                textAlign: 'right',
                paddingRight: '20px' // Karakter sayacını da kenar boşluğu ile hizalıyoruz
              }}>
                Karakter: {caption.length}/200
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ✅ YENİ: Progress Bar (Sadece yükleme sırasında görünür) */}
      {isUploading && (
        <div style={{ width: '100%', backgroundColor: '#e0e0e0', borderRadius: '8px', margin: '15px 0', height: '10px', overflow: 'hidden' }}>
          <div
            style={{
              width: `${uploadProgress}%`,
              backgroundColor: '#4CAF50', // Yeşil bar
              height: '100%',
              transition: 'width 0.3s ease'
            }}
          />
        </div>
      )}

      <button
        onClick={handleUpload}
        className="upload-button"
        disabled={disabled || selectedFiles.length === 0}
        style={{
          marginTop: isUploading ? 5 : 20,
          background: isSuccess ? '#4CAF50' : undefined,
          color: 'white',
          opacity: isUploading ? 0.8 : 1
        }}
      >
        {isUploading ? `Yükleniyor... %${uploadProgress}` : isSuccess ? 'Tamamlandı!' : `Yükle (${selectedFiles.length})`}
      </button>

      {message && (
        <p
          className="upload-message"
          style={{
            marginTop: 10,
            fontWeight: '600',
            color: isSuccess ? '#2e7d32' : '#d32f2f'
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default UploadForm;